import module from 'nominas/nomina/module.js'
import template from './template.html'
import moment from 'moment'

export default class NominasCargaserviciosGuardarComponent {
  constructor (dialog, $dialogParams, $http) {
    this.dialog = dialog
    this.$http = $http
    this.procesando = false
    this.error = null
    this.data = {
      services: $dialogParams.services,
      companies: [],
      concepts: {},
      total: 0,
    }
    this.opciones = {
      notas: '',
      fecha: new Date(),
    }
    this.data.services.forEach((item) => {
      if (this.data.companies.indexOf(item.Empresa) < 0) {
        this.data.companies.push(item.Empresa)
      }

      if (!this.data.concepts[item.Codigo_Movimiento]) {
        this.data.concepts[item.Codigo_Movimiento] = {
          id_tipo_movimiento: item.Codigo_Movimiento,
          concepto: item.Concepto,
          naturaleza: item.Naturaleza,
          moneda: parseInt(item.Tipo_Moneda) === 1 ? 'MXN' : 'USD',
          cantidad: 0,
          total: 0,
        }
      }
      this.data.concepts[item.Codigo_Movimiento].total += item.Importe
      this.data.concepts[item.Codigo_Movimiento].cantidad++
      this.data.total += item.Importe
    })
  }

  guardar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    let data = this.data.services.map((row) => ({
      UID: row.UID,
      ID_Empresa: row.ID_Empresa,
      ID_Empleado: row.ID_Empleado,
      Codigo_Movimiento: row.Codigo_Movimiento,
      Fecha_Movimiento: moment(this.opciones.fecha).format('YYYY-MM-DD'),
      Tipo: row.Tipo,
      Tipo_Moneda: row.Tipo_Moneda,
      Naturaleza: row.Naturaleza,
      Importe: row.Importe,
      Notas: `${row.Naturaleza === 'C' ? 'Cargo/Charge' : 'Abono/Deposit'}[${row.Codigo_Movimiento}] ${row.Notas || this.opciones.notas}`,
    }))

    this.$http.post('kendu/finanzas/cargaServicios/guardar', {servicios: data})
      .then((response) => (this.dialog.resolve(response.data)))
      .catch((response) => (this.error = response.data))
      .finally(() => (this.procesando = false))
  }

  cancelar () {
    this.dialog.reject()
  }
}

module.controller('NominasCargaserviciosGuardar', NominasCargaserviciosGuardarComponent)
module.config(($dialogProvider) => {
  $dialogProvider.dialog('nominas.cargaServicios.guardar', {
    controller: 'NominasCargaserviciosGuardar',
    template,
    controllerAs: '$ctrl',
  })
})



// WEBPACK FOOTER //
// ./src/nominas/cargaservicios/components/guardar/component.js